import React from "react";
import { TimePicker } from "antd";
const format = "HH:mm";
const TimeArrival = ({ index, values, handleChange }) => {
  return (
    <>
      <input
        placeholder="hh:mm"
        type="time"
        className="form-control" // name="arrivalTime"
        id={`flightLegs.onward[${index}].arrivalTime`}
        name={`flightLegs.onward[${index}].arrivalTime`}
        // display="Request Date"
        // onBlur={handleBlur}
        value={values?.flightLegs?.onward[index]?.arrivalTime || ""}
        onChange={handleChange}
        // touched={touched?.flightLegs?.onward[index]?.arrivalTime}
        // error={errors?.flightLegs?.onward[index]?.arrivalTime}
      />
    </>
  );
};

export default TimeArrival;
